import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { FieldLabel } from '@cp/ds/src/components/form/label';
import { DateTimePicker } from '@cp/ds/src/components/form/components/field/dateTimePicker';
import { styled } from '@cp/ds';
import { Typography } from '@cp/ds/src/components/typography';
import { Stack } from '@cp/ds/src/components/stack';
import { SVGIconTokens } from '@cp/ds/src/components/svgIcon';
import { FormFieldName } from '../model/form';

const Dash = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  maxWidth: '12px',
  width: '100%',
}));

const Placeholder = styled(Typography)(({ theme }) => ({
  color: theme.palette.gray,
}));

const Wrapper = styled(Stack)({ gap: '4px', [SVGIconTokens.Size]: '16px' });

export const DateField: React.FC = () => {
  return (
    <Wrapper>
      <FieldLabel size="small">Время заказа</FieldLabel>
      <Wrapper alignItems="center" direction="row">
        <DateTimePicker
          name={FormFieldName.DateStart}
          pickerType="time"
          placeholder={<Placeholder variant="caption">Начало</Placeholder>}
          size="small"
          type={'dateTimePicker'}
        />
        <Dash />
        <DateTimePicker
          name={FormFieldName.DateEnd}
          pickerType="time"
          placeholder={<Placeholder variant="caption">Конец</Placeholder>}
          size="small"
          type={'dateTimePicker'}
        />
      </Wrapper>
    </Wrapper>
  );
};
